import { Button } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useTrackDemoInvoiceEditor } from '../../hooks/useTrackDemoInvoiceEditor'
import { getPrintableInvoiceHtml } from '../../utils/getPrintableInvoiceHtml'
import { printHtml } from '../../utils/printHtml'

interface DemoInvoiceDownloadButtonProps {
  htmlFiles?: string[]
}

export const DemoInvoiceDownloadButton = ({ htmlFiles }: DemoInvoiceDownloadButtonProps): ReactElement => {
  const { t } = useTranslation()
  const { trackDemoInvoiceEditor } = useTrackDemoInvoiceEditor()

  const handleClick = useCallback(() => {
    if (htmlFiles?.length) {
      trackDemoInvoiceEditor('Download button clicked')
      printHtml(getPrintableInvoiceHtml(htmlFiles))
    }
  }, [htmlFiles, trackDemoInvoiceEditor])

  return (
    <Button disabled={!htmlFiles?.length} icon="download" onClick={handleClick}>
      {t('demo_invoice.preview.download')}
    </Button>
  )
}
